/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

interface StudyTimerState {
  hours: number;
  minutes: number;
  seconds: number;
  isTimeSubmit: boolean;
  isTimePause: boolean;
  isModalOpen: boolean;
}

const initialState: StudyTimerState = {
  hours: 0,
  minutes: 0,
  seconds: 0,
  isTimeSubmit: false,
  isTimePause: false,
  isModalOpen: false,
};

export const studyTimerSlice = createSlice({
  name: "studyTimer",
  initialState,
  reducers: {
    incrementSeconds: state => {
      state.seconds = (state.seconds + 1) % 60;
    },
    decrementSeconds: state => {
      state.seconds = (state.seconds - 1 + 60) % 60;
    },
    incrementMinutes: state => {
      // state.minutes++;
      state.minutes = (state.minutes + 1) % 60;
    },
    decrementMinutes: state => {
      //state.minutes--;
      state.minutes = (state.minutes - 1 + 60) % 60;
    },
    incrementHours: state => {
      state.hours++;
    },
    decrementHours: state => {
      state.hours--;
    },
    isSecondZeroChangeMinutes: state => {
      state.minutes = Math.max(state.minutes - 1, 0);
    },
    incrementMinutesByAmount: (state, action: PayloadAction<number>) => {
      state.minutes += action.payload;
    },
    changeSeconds: (state, action: PayloadAction<number>) => {
      state.seconds = action.payload;
    },
    changeMinutes: (state, action: PayloadAction<number>) => {
      state.minutes = action.payload;
    },
    changeHours: (state, action: PayloadAction<number>) => {
      state.hours = action.payload;
    },
    handleGlobalModalClose: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    handleGlobalTimeSubmit: (state, action: PayloadAction<boolean>) => {
      state.isTimeSubmit = action.payload;
    },
    handleGlobalTimePause: (state, action: PayloadAction<boolean>) => {
      state.isTimePause = action.payload;
    },
  },
});

export const {
  incrementSeconds,
  decrementSeconds,
  incrementMinutes,
  decrementMinutes,
  incrementHours,
  decrementHours,
  incrementMinutesByAmount,
  isSecondZeroChangeMinutes,
  changeSeconds,
  changeMinutes,
  changeHours,
  handleGlobalModalClose,
  handleGlobalTimeSubmit,
  handleGlobalTimePause,
} = studyTimerSlice.actions;
export default studyTimerSlice.reducer;
